export const environment = {
    production: true
};



// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/environments/environment.ts